module.exports = __webpack_public_path__ + "static/media/sede-administrativa.54f04643.jpeg";